var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",style:({ top: _vm.top + 'px', left: _vm.left + 'px', right: _vm.right + 'px' }),on:{"click":_vm.backHandle}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" 返回 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }